import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const entryCss = css({
  display: "grid",
  gridTemplateColumns: "min-content auto",
  columnGap: "12px",
  alignItems: "center",
});

export const titleCss = css({
  wordBreak: "break-word",
});

export const entryFooterCss = css({
  display: "grid",
  gridTemplate: "'avatars . accounts . updated-at' auto / max-content 5px fit-content(85%) 10px auto",
});

export const avatarsCss = css({
  gridArea: "avatars",
});

export const accountsCss = css({
  gridArea: "accounts",
  ...fontSize(12),
  color: tokens.color.text.secondary.default.value,
});

export const updatedAtCss = css({
  gridArea: "updated-at",
  ...fontSize(12),
  color: tokens.color.text.secondary.default.value,
});
